<template>
  <div class="animated fadeIn">
    <spot-prices/>

    <div class="row">
      <div class="col-12">
        <table class="table table-bordered table-striped">
          <thead>
            <tr>
              <th>Metal</th>
              <th>Bid</th>
              <th>Ask</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="align-right">Gold</td>
              <td class="align-middle"><input v-model="adjustment.gold_bid" class="form-control text-right form-control-sm" style="width: 80px"></td>
              <td class="align-middle"><input v-model="adjustment.gold_ask" class="form-control text-right form-control-sm" style="width: 80px"></td>
            </tr>
            <tr>
              <td class="align-right">Silver</td>
              <td class="align-middle"><input v-model="adjustment.silver_bid" class="form-control text-right form-control-sm" style="width: 80px"></td>
              <td class="align-middle"><input v-model="adjustment.silver_ask" class="form-control text-right form-control-sm" style="width: 80px"></td>
            </tr>
            <tr>
              <td class="align-right">Platinum</td>
              <td class="align-middle"><input v-model="adjustment.platinum_bid" class="form-control text-right form-control-sm" style="width: 80px"></td>
              <td class="align-middle"><input v-model="adjustment.platinum_ask" class="form-control text-right form-control-sm" style="width: 80px"></td>
            </tr>
            <tr>
              <td class="align-right">Palladium</td>
              <td class="align-middle"><input v-model="adjustment.palladium_bid" class="form-control text-right form-control-sm" style="width: 80px"></td>
              <td class="align-middle"><input v-model="adjustment.palladium_ask" class="form-control text-right form-control-sm" style="width: 80px"></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="col-12">
      <button type="button" class="btn btn-primary" v-on:click="savePrice()"><i class="fa fa-save"></i>&nbsp; Save Price Adjustment</button>
    </div>
    <announcement></announcement>
  </div>
</template>

<script>
  import { Announcement } from '../../components/'
  export default {
    name: 'pricing',
    components: {
      Announcement
    },
    data () {
      return {
        context: 'pricing context',
        adjustment: {
          gold_bid: 0.0,
          gold_ask: 0.0,
          silver_bid: 0.0,
          silver_ask: 0.0,
          palladium_bid: 0.0,
          palladium_ask: 0.0,
          platinum_bid: 0.0,
          platinum_ask: 0.0
        }
      }
    },
    methods: {
      savePrice () {
        this.$http.post('quote/adjust', this.adjustment).then(response => {
          console.log(response)
        }, response => {
          console.log(response)
        })
      },
      getAdjustments () {
        this.$http.get('quote/adjust', this.adjustment).then(response => {
          const adjData = JSON.parse(response.body)
          this.adjustment.gold_bid = adjData['gold_bid']
          this.adjustment.gold_ask = adjData['gold_ask']
          this.adjustment.silver_bid = adjData['silver_bid']
          this.adjustment.silver_ask = adjData['silver_ask']
          this.adjustment.palladium_bid = adjData['palladium_bid']
          this.adjustment.palladium_ask = adjData['palladium_ask']
          this.adjustment.platinum_bid = adjData['platinum_bid']
          this.adjustment.platinum_ask = adjData['platinum_ask']
        }, response => {
          console.log(response)
        })
      }
    },
    beforeMount () {
      this.getAdjustments()
    }
  }
</script>



// WEBPACK FOOTER //
// Pricing.vue?405f5a56